import type {ProductSubscription} from 'src/openapi/admin/models/ProductSubscription';

const UNLIMITED_SEATS = 2_147_483_647;

export const getSubscriptionSeatText = (subscription: ProductSubscription) => (
    subscription.seats === UNLIMITED_SEATS
        ? `${subscription.activeSeatCount} / Unlimited`
        : `${subscription.activeSeatCount} / ${subscription.seats} seats`
);

export const isUnlimitedSubscription = (subscription: ProductSubscription) => (
    subscription.seats === UNLIMITED_SEATS
);
